import { Buffer } from 'buffer';

// @solana/spl-token references Buffer at module-eval time. ESM hoists imports,
// so this must live in a module imported *before* anything that pulls spl-token.
(globalThis as unknown as { Buffer: typeof Buffer }).Buffer = Buffer;
